import React from "react";
import "./Footer.scss";

const Footer = () => {
    return (
        <footer className="app-footer">
            <div className="footer-content">
                Copyright &copy; 2026 SpiceTech System Pvt Ltd. All Rights Reserved
            </div>
        </footer>
    );
};

export default Footer;